import { Component, ElementRef, Input, OnInit, OnDestroy, Inject } from '@angular/core';
import * as $ from 'jquery';

import { ModalsHandlerServiceNg2 } from './SimplaexModalsHandlerServiceNg2';

@Component({
    selector: 'spx-modal-ng2',
    template: '<ng-content></ng-content>'
})

export class SimplaexModalComponentNg2 implements OnInit, OnDestroy {
    @Input() id: string;
    private element: JQuery;

    constructor(@Inject(ModalsHandlerServiceNg2) private modalService: ModalsHandlerServiceNg2, @Inject(ElementRef) private el: ElementRef) {
        this.element = $(el.nativeElement);
    }

    ngOnInit(): void {
        let modal = this;

        // ensure id attribute exists
        if (!this.id) {
            console.error('modal must have an id');
            return;
        }

        // move element to bottom of page (just before </body>) so it can be displayed above everything else
        this.element.appendTo('body');

        // close modal on background click
        this.element.on('click', function (e: any) {
            var target = $(e.target);
            if (
                // excluding from the targets any a or span that looks like ng-table footer and header elements
                // don't know why but for them target.closest('.modal-body').length is 0
                !(
                    target.is('a') && target.parent().is('li') && !target.is('span') ||
                    target.parent().is('a') && target.parent().parent().is('li') ||
                    target.is('th') ||
                    target.is('.ng-table-header') ||
                    target.is('span') && target.parent().is('.ng-table-header')

                ) &&
                target.closest('.modal-body').length == 0
            ) {
                modal.close();
            }
        });

        // add self (this modal instance) to the modal service so it's accessible from controllers
        this.modalService.add(this);
    }

    // remove self from modal service when directive is destroyed
    ngOnDestroy(): void {
        this.modalService.remove(this.id);
        this.element.remove();
    }

    // open modal
    open(): void {
        this.element.show();
        $('body').addClass('modal-open');
        // some content of the modal, (i.e. countries map) gets rendered in a smaller size.
        // triggering a resize makes it render again to the proper size.
        var evt = window.document.createEvent('UIEvents');
        evt.initUIEvent('resize', true, false, window, 0);
        window.dispatchEvent(evt);

        // Scrolling to the top
        this.element.find('.modal').scrollTop(0);
    }

    // close modal
    close(): void {
        this.element.hide();
        $('body').removeClass('modal-open');
    }
}


/** WEBPACK FOOTER **
 ** ./src/common/modal/ng2/SimplaexModalComponentNg2.ts
 **/